var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.383-50-50-50h-300c-27.6172 0-50 22.3828-50 50v380c0 27.613 22.3828 50 50 50h240l110-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#9a50a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6172 22.3828-50 50-50h300c27.617 0 50 22.3828 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0625-17.937-40-40-40h-300c-22.0586 0-40 17.9375-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#884792"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.793v96.793z",
    fill: "#884792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.617 0-50 22.387-50 50v60h110z",
    fill: "#cdacd2"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.9805 417.699h14.7855l10.808-34.586 10.813 34.586h14.258l7.421-57.699h-11.836l-5.097 40.605-12.695-40.605h-5.645l-13.035 40.957-4.817-40.957h-12.0387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.563 407.328v-14.765h4.832c2.082 0 3.859.746 5.339 2.242 1.477 1.492 2.219 3.265 2.219 5.316 0 2.344-.84 4.16-2.5 5.449-1.68 1.289-4.043 1.934-7.129 1.934zm-12.18 10.371h19.734c5.305 0 9.582-1.547 12.832-4.633 3.254-3.093 4.875-7.156 4.875-12.199 0-3.308-.801-6.453-2.39-9.422-1.594-2.976-4.004-5.195-7.231-6.66-3.223-1.465-5.973-2.226-8.262-2.285l-7.207-.176v-22.324h-12.351z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.863 400.035h-11.328c.352 5.125 2.227 9.242 5.645 12.348 3.41 3.105 7.5 4.66 12.285 4.66 5.234 0 9.695-1.488 13.379-4.461 3.672-2.969 5.508-6.547 5.508-10.73 0-4.571-2.247-8.696-6.758-12.387 2.871-1.817 4.961-3.719 6.308-5.695 1.328-1.977 1.993-4.344 1.993-7.098 0-5.25-1.739-9.461-5.235-12.625-3.476-3.168-8.097-4.75-13.84-4.75-5.332 0-9.754 1.516-13.25 4.551-3.496 3.027-5.664 7.242-6.484 12.632h11.602c1.386-5.332 4.035-8 7.957-8 1.964 0 3.625.7 4.972 2.094 1.348 1.395 2.012 3.121 2.012 5.18 0 2.527-.801 4.59-2.441 6.191-1.622 1.602-3.711 2.403-6.25 2.403h-2.071v9.445h1.231c2.668 0 4.804.66 6.418 1.973 1.609 1.316 2.41 3.054 2.41 5.211 0 1.957-.625 3.632-1.914 5.019-1.27 1.387-2.832 2.082-4.668 2.082-4.317 0-6.797-2.683-7.481-8.043"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m186.887 238.727c-4.934-.696-8.606-4.911-8.606-9.911v-42.769-69.797c-4.718 1.875-9.941 3.008-15.527 3.008-19.895 0-36.016-13.262-36.016-29.6291 0-16.3476 16.121-29.6289 36.016-29.6289 19.883 0 35.996 13.2813 35.996 29.6289v99.3091l100.781 14.214v-66.902c-4.718 1.875-9.953 3.008-15.539 3.008-19.89 0-36.012-13.262-36.012-29.629 0-16.3477 16.122-29.629 36.012-29.629 19.887 0 36.008 13.2813 36.008 29.629v96.418 39.953c0 2.902-1.262 5.656-3.437 7.551-2.188 1.902-5.086 2.762-7.958 2.351z",
    fill: "#e0e0e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.3cd13d5933ad99345779262672dc4445.svg";
export { ForwardRef as ReactComponent };